/**
 * F-003 Phase 1b: WebSocket bearer auth via Sec-WebSocket-Protocol (no JWT in query string).
 * Mirrors server/src/lib/ws-auth-protocol.ts
 */
export const WS_BEARER_PROTOCOL_PREFIX = "oktogo.bearer.";

function base64UrlEncodeUtf8(value: string): string {
  const bytes = new TextEncoder().encode(value);
  let binary = "";
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
}

export function encodeWsBearerSubprotocol(accessToken: string): string {
  const trimmed = accessToken.trim();
  if (!trimmed) throw new Error("Access token required for WebSocket subprotocol");
  return `${WS_BEARER_PROTOCOL_PREFIX}${base64UrlEncodeUtf8(trimmed)}`;
}

export function decodeWsBearerSubprotocol(protocolEntry: string): string | null {
  const entry = protocolEntry.trim();
  if (!entry.startsWith(WS_BEARER_PROTOCOL_PREFIX)) return null;
  const encoded = entry.slice(WS_BEARER_PROTOCOL_PREFIX.length);
  if (!encoded) return null;
  try {
    const base64 = encoded.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
    const binary = atob(padded);
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
    const token = new TextDecoder().decode(bytes).trim();
    return token || null;
  } catch {
    return null;
  }
}
